import React from 'react';
import { useSelector } from 'react-redux';
import { getSelectedShowAccountDetails } from '../../store/accountListSlice';
import { AppState } from '../../interfaces/store.interface';
import { getFeatureToShow } from '../../store/paymentTokenSlice';
import AccountDetails from './accountDetails/AccountDetails';
import SingleUseCard from '../singleUseCard/SingleUseCard';
import CreditLimitIncrease from '../creditLimitIncrease/CreditLimitIncrease';
import ShoppingPass from '../shoppingPass/ShoppingPass';
import { FEATURES_TO_DISPLAY } from '../../utils/constants/genericConstants';
import '../singleUseCard/singleUseCard.css';

const AccordionBody = (props: any) => {
  const { account, isAccordionCollapsed, index } = props;
  const {
    SINGLE_USE_CARD,
    VIRTUAL_CARD,
    SHOPPING_BARCODE,
    CREDIT_LIMIT_INCREASE,
  } = FEATURES_TO_DISPLAY;
  const showAccountDetails = useSelector((state: AppState) =>
    getSelectedShowAccountDetails(state, account.accountId),
  );
  const featureName = useSelector(getFeatureToShow);

  const switchFeaturesToDisplay = (name: string) => {
    let feature = null;
    switch (name) {
      case SINGLE_USE_CARD:
        feature = <SingleUseCard {...props} />;
        break;
      case CREDIT_LIMIT_INCREASE:
        feature = <CreditLimitIncrease {...props} />;
        break;
      case SHOPPING_BARCODE:
        feature = <ShoppingPass {...props} />;
        break;
      case VIRTUAL_CARD:
        feature = <div>Virtual card feature</div>;
        break;
      default:
        feature = <div>no feature selected</div>;
        break;
    }
    return feature;
  };

  return (
    <div>
      {showAccountDetails ? (
        <AccountDetails
          {...account}
          isAccordionCollapsed={isAccordionCollapsed}
          index={index}
        />
      ) : (
        <>
          {/* switch which changes individual features and renders them here. */}
          {featureName && switchFeaturesToDisplay(featureName)}
        </>
      )}
      {featureName === CREDIT_LIMIT_INCREASE && (
        <>
          {/* switch which changes individual features and renders them here. */}
          {featureName && switchFeaturesToDisplay(featureName)}
        </>
      )}
    </div>
  );
};

export default AccordionBody;
